<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <app-section
    title="1. Atividade (CNAE)"
    description="O CNAE é o começo da cadeia: ele indica quais itens da LC 116 a empresa costuma prestar. Os campos seguintes só abrem depois dele."
  >
    <app-fields>
      <app-input
        formControlName="cnae"
        mask="0000-0/00"
        label="CNAE"
        hint="Subclasse com 7 dígitos, como na Receita (ex.: 4330-4/02)."
        invalidMessage="Informe o CNAE completo (7 dígitos)"
      ></app-input>
    </app-fields>
    <app-fields *ngIf="sugestoesOptions().length">
      <app-select
        formControlName="sugestao"
        label="Serviço sugerido para este CNAE"
        [options]="sugestoesOptions()"
      >
        <small class="hint">
          Sugestão de item da LC 116 a partir do CNAE. Você pode ignorar e
          escolher o item na lista abaixo.
        </small>
      </app-select>
    </app-fields>
    <p class="aviso" *ngIf="buscandoSugestoes()">
      <i class="pi pi-spin pi-spinner"></i> Buscando serviços do CNAE…
    </p>
  </app-section>

  <div
    class="etapa"
    [class.bloqueada]="!cnaeOk()"
    [attr.inert]="cnaeOk() ? null : ''"
  >
    <app-section
      title="2. Serviço (item da LC 116)"
      description="O item da LC 116 é o que define o serviço tributado pelo ISS. Escolha o item e o sub-item: o código de 6 dígitos exigido na emissão é montado a partir deles."
    >
      <p class="trava" *ngIf="!cnaeOk()">
        <i class="pi pi-lock"></i> Informe o CNAE para liberar esta etapa.
      </p>
      <app-fields>
        <app-select
          formControlName="itemLc116"
          label="Item da LC 116"
          [options]="itensLc116"
          [filter]="true"
          [virtualScroll]="true"
        ></app-select>
        <app-select
          formControlName="subItem"
          label="Sub-item da LC 116"
          [options]="subItens()"
          [filter]="true"
        ></app-select>
      </app-fields>
      <app-fields>
        <app-input
          formControlName="codigo"
          mask="00.00||00.00.00"
          label="Código do serviço"
          hint="Preenchido pelo item e sub-item. Aceita 4 dígitos (07.06) ou 6 dígitos (07.06.02)."
          invalidMessage="Informe 4 dígitos (07.06) ou 6 dígitos (07.06.02)"
        ></app-input>
        <app-input
          formControlName="codigoTributacao"
          mask="0{20}"
          [maxlength]="20"
          label="Código de tributação do município"
          hint="Código próprio da prefeitura. Em Fortaleza é obrigatório: CNAE + 2 dígitos de desdobramento (9 dígitos, ex.: 433040203), conforme a consulta de atividades da Sefin."
          invalidMessage="Os 7 primeiros dígitos precisam ser iguais ao CNAE do serviço (código de tributação = CNAE + desdobramento)."
        ></app-input>
      </app-fields>
      <app-fields>
        <app-input
          formControlName="nome"
          label="Nome do serviço"
          [maxlength]="120"
          hint="Apelido para achar o serviço nas listas (opcional). Não sai na nota."
        ></app-input>
      </app-fields>
      <app-fields>
        <app-input
          type="textarea"
          formControlName="discriminacao"
          label="Discriminação"
          [maxlength]="discriminacaoMax"
          hint="Texto que sai na nota. Vem da descrição do sub-item; pode ser ajustado aqui e também em cada emissão."
        ></app-input>
      </app-fields>
    </app-section>
  </div>

  <div
    class="etapa"
    [class.bloqueada]="!servicoOk()"
    [attr.inert]="servicoOk() ? null : ''"
  >
    <app-section
      title="3. NBS"
      description="A NBS detalha o serviço para o IBS/CBS e precisa corresponder ao item da LC 116 escolhido acima."
    >
      <p class="trava" *ngIf="!servicoOk()">
        <i class="pi pi-lock"></i> Escolha o item da LC 116 e a discriminação
        para liberar esta etapa.
      </p>
      <app-fields>
        <app-input
          formControlName="codigoNbs"
          mask="0.0000.00.00"
          label="Código NBS"
          hint="9 dígitos. O sistema não deduz a NBS: confirme a correspondência com o item da LC 116."
          invalidMessage="A NBS tem 9 dígitos (ex.: 1.1401.12.00)"
        ></app-input>
      </app-fields>
    </app-section>
  </div>

  <div
    class="etapa"
    [class.bloqueada]="!nbsOk()"
    [attr.inert]="nbsOk() ? null : ''"
  >
    <app-section
      title="4. ISS"
      description="Alíquota do município para este item da LC 116. Tipo de tributação e exigibilidade são escolhidos na emissão, porque dependem do local de prestação da nota."
      formGroupName="iss"
    >
      <p class="trava" *ngIf="!nbsOk()">
        <i class="pi pi-lock"></i> Informe a NBS para liberar esta etapa.
      </p>
      <app-fields>
        <app-input
          label="Alíquota"
          mask="percent.2"
          formControlName="aliquota"
        ></app-input>
        <app-select
          formControlName="retido"
          label="Retido?"
          [options]="yon"
        ></app-select>
      </app-fields>
    </app-section>
  </div>

  <div
    class="etapa"
    [class.bloqueada]="!issOk()"
    [attr.inert]="issOk() ? null : ''"
  >
    <app-section
      title="5. IBS/CBS (Reforma Tributária)"
      description="A classificação tributária depende do CST, que por sua vez depende do serviço e da NBS. Os códigos são do contador — o sistema não sugere nenhum."
      formGroupName="ibscbs"
    >
      <p class="trava" *ngIf="!issOk()">
        <i class="pi pi-lock"></i> Informe a alíquota do ISS para liberar esta
        etapa.
      </p>
      <app-fields>
        <app-input
          formControlName="codigoOperacao"
          mask="000000"
          label="Código da operação"
        ></app-input>
        <ng-container formGroupName="valores">
          <ng-container formGroupName="tributacao">
            <app-input
              formControlName="cst"
              mask="000"
              label="Situação tributária IBS/CBS (CST)"
              invalidMessage="O CST tem 3 dígitos"
            ></app-input>
            <app-input
              formControlName="cct"
              mask="000000"
              label="Classificação tributária IBS/CBS (cClassTrib)"
              hint="Precisa ser compatível com o CST informado."
              invalidMessage="A classificação tributária tem 6 dígitos"
            ></app-input>
          </ng-container>
        </ng-container>
        <app-input
          formControlName="operacaoPessoal"
          mask="0"
          label="Operação de uso pessoal (0 ou 1)"
        ></app-input>
      </app-fields>
    </app-section>
  </div>

  <div
    class="etapa"
    [class.bloqueada]="!ibscbsOk()"
    [attr.inert]="ibscbsOk() ? null : ''"
  >
    <app-section
      title="6. Obra e observações"
      description="Preencha apenas quando o serviço for obra civil ou construção."
    >
      <p class="trava" *ngIf="!ibscbsOk()">
        <i class="pi pi-lock"></i> Complete o IBS/CBS para liberar esta etapa.
      </p>
      <p class="trava aviso-obra" *ngIf="obraExigida() && !obraPreenchida()">
        <i class="pi pi-exclamation-triangle"></i> Item de construção civil
        (07.02, 07.04, 07.05, 07.06, 07.07, 07.08, 07.17 e 07.19): a prefeitura
        exige o código da obra e a ART na nota. Sem eles a NFS-e é rejeitada
        (Fortaleza: E630).
      </p>
      <app-fields formGroupName="obra">
        <app-input label="Código da ART" formControlName="art"></app-input>
        <app-input
          label="Código da obra (CO)"
          formControlName="codigo"
        ></app-input>
        <app-input
          label="Cadastro específico do ISS"
          formControlName="cei"
        ></app-input>
      </app-fields>
      <app-fields>
        <app-input
          type="textarea"
          formControlName="informacoesComplementares"
          label="Informações complementares"
        ></app-input>
      </app-fields>
    </app-section>
  </div>

  <div class="submit">
    <app-button
      [disabled]="!form.valid || isLoading"
      type="submit"
      backgroundColor="var(--blue-500)"
      [icon]="submitIcon"
      [text]="isLoading ? 'Salvando...' : submitText"
    ></app-button>
  </div>
</form>
